import { datadogRum } from '@datadog/browser-rum';
import isEmpty from 'lodash/isEmpty';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

const getEnvForDatadog = () => {
  if (['production', 'qa', 'staging'].includes(publicRuntimeConfig.nodeEnv)) {
    return publicRuntimeConfig.nodeEnv;
  }
  return 'dev';
};

const start = () => {
  datadogRum.init({
    applicationId: publicRuntimeConfig.datadogRumApplicationId,
    clientToken: publicRuntimeConfig.datadogRumClientToken,
    site: 'datadoghq.com',
    service: 'webreg',
    env: getEnvForDatadog(),
    // Specify a version number to identify the deployed version of your application in Datadog
    version: publicRuntimeConfig.version,
    sampleRate: 100,
    trackInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingOrigins: [
      // Note: allowedTracingOrigins accepts Javascript String and RegExp that should match the origins called by your browser application,
      // with origin defined as: <scheme> "://" <hostname> [ ":" <port> ]
      // https://docs.datadoghq.com/real_user_monitoring/connect_rum_and_traces?tab=browserrum
      publicRuntimeConfig.webregServiceURL,
      publicRuntimeConfig.apiRootUrl
    ],
    beforeSend: event => {
      // eslint-disable-next-line no-param-reassign
      event.resource.url = event.resource.url.replace(
        /(reset-password\/parent\/[^/]+\/)[^/]+/,
        '$1REDACTED'
      );
    }
  });

  datadogRum.startSessionReplayRecording();
};

const addAction = (actionName, contextAttributes = {}) => {
  if (isEmpty(contextAttributes)) {
    datadogRum.addAction(actionName);
  } else {
    datadogRum.addAction(actionName, contextAttributes);
  }
};

const addError = (error, contextAttributes = {}) => {
  if (isEmpty(contextAttributes)) {
    datadogRum.addError(error);
  } else {
    datadogRum.addError(error, contextAttributes);
  }
};

const setRumUser = (anonymousId, { id, phoneNumber } = {}) => {
  const args = { anonymousId };

  if (id) {
    args.id = id;
  }
  if (phoneNumber) {
    args.phoneNumber = phoneNumber;
  }

  datadogRum.setUser(args);
};

const setRumUserProperties = datadogRum.setUser;

const addRumGlobalContext = (key, val) => {
  datadogRum.addRumGlobalContext(key, val);
};

export const exportedForTests = {
  getEnvForDatadog
};

export default {
  start,
  addAction,
  addError,
  setRumUser,
  setRumUserProperties,
  addRumGlobalContext
};
